import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from "@mui/material";

interface ConfirmDeleteProps extends DialogProps {
  onDelete: () => void;
  onCancel: () => void;
  action: "delete" | "remove";
  children: JSX.Element;
  title?: string;
}

export const ConfirmDeleteResourceDialog: React.FC<ConfirmDeleteProps> = ({
  onDelete,
  onCancel,
  action,
  children,
  title,
  ...dialogProps
}) => {
  return (
    <Dialog
      {...dialogProps}
      data-testid="confirm-delete-dialog"
      onClose={onCancel}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button variant="outlined" color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onDelete}
          data-testid="confirm-delete-dialog-delete-button"
        >
          {action === "delete" ? "Delete" : "Remove"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
